<template>
    <div>
        <Header/>
        <Nav :list="headerList"/>
        <div ref="content">
            <SingleBanner/>
            <div class="page-content">
                <div class="page-content-left">
                    <div class="page-content-left-title">{{aboutxiehuiObj.zaizhongguo.title}}</div>
                    <div class="page-content-left-content">
                        <div v-for="(item, index) in list" :key="index" class="single">
                            <div class="remark">
                                <div class="round"><span/></div>
                                <div v-if="index+1<list.length" class="line"/>
                            </div>
                            <div class="subcontent">
                                <div class="time">{{item.intro}}</div>
                                <div class="info" v-html="item.content"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="page-content-right">
                    <RightTab :list="arr"/>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
</template>
<script>
import RightTab from './components/rightTab.vue';
import { mapState } from 'vuex'
export default {
    computed: mapState([
        'aboutxiehuiObj'
    ]),
    components:{
       RightTab,
    },
    data() {
        return {
            headerList:[
                {name:'首页', href:'/'},
                {name:'关于协会', href:'/aboutISOC'},
                {name:'IFM在中国', href:'/ifmDesc'},
            ],
            arr:[
                {name:'IFM简介',url:'/ifmDesc'},
                {name:'理事会成员',url:'/ifmLishihui'},
                {name:'IFM在中国',url:'/ifmInChina'},
                {name:'专家团队',url:'/grop'},
            ],
            list:[
            ]
        }
    },
    mounted(){
        this.$http.get('/api/index/getNavNodes',{nodeName:'IFM在中国'}).then(res => {
            if(res){
                this.list = res;
            }
        })
    },
    methods: {
        
    },
}
</script>
<style lang="scss" scoped>
.single{
    width: 100%;
    display: flex;
    justify-content: space-between;
}
.remark{
    width:15px;
    .round{
        position: relative;
        width:15px;
        height:15px;
        border-radius: 50%;
        background: #ca9093;
        span{
            display: inline-block;
            position: absolute;
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background: #840108;
            left:4px;
            top:4px;
        }
    }
    .line{
        height:calc(100% - 15px);
        width:1px;
        background: #e9e8e8;
        margin-left: 7px;
    }
}
.subcontent{
    width:800px;
    padding-bottom: 27px;
    padding-right: 42px;
    box-sizing: border-box;
    .time{
        font-size: 18px;
        color: #3B3B3B;
        letter-spacing: 0.51px;
        line-height: 15px;
        font-weight: 500;
    }
    .info{
        font-size: 14px;
        color: #3B3B3B;
        margin-top: 16px;
        letter-spacing: 0.51px;
        line-height: 20px;
        font-weight: 400;    
    }
}
</style>
